// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBdTzOrn5Dj1DsPEiOSjsyNSho3HppYIEU",
    authDomain: "hackdaysgame.firebaseapp.com",
    databaseURL: "https://hackdaysgame.firebaseio.com",
    projectId: "hackdaysgame",
    storageBucket: "hackdaysgame.appspot.com",
    messagingSenderId: "175182705232",
    appId: "1:175182705232:web:2afd7373cf09ff81f01755",
    measurementId: "G-67EVXX4RF4"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
